<template>
  <div class="w-full h-full flex flex-col items-center justify-center relative gap-5">
    <GameCardItem v-if="cardToTrade" :card="cardToTrade" :isActive="false" />
    <CardSwapIcon class="absolute top-[50%] left-[50%] z-3 -translate-x-1/2 -translate-y-1/2 w-16 h-auto" />
    <GameCardItem :isLetterCard="true" :letter v-if="currentTypeCard" :card="currentTypeCard" :showLetter="false" :showRank="false" />
  </div>
</template>

<script setup lang="ts">
import GameCardItem from '@/components/game-play/GameCardItem.vue'
import CardSwapIcon from '@/assets/svgs/icons/card-swap-arrows.svg'
import type { CardT } from '@/types/Game'

const { letter, currentTypeCard, cardToTrade } = defineProps<{
  letter: string
  currentTypeCard: CardT | null
  cardToTrade: CardT | null
}>()
</script>
